module.exports = {
  label: 'File History',
  Details: '詳細',
  view: 'View File',
  PlsInput: 'Pls Input',
  Query: 'Query',
  fileName: 'ファイル名',
  fileVersion: 'バージョン',
  jobType: '種類',
  fileType: 'フォマード',
  fileSize: 'サイズ',
  createdBy: '担当者',
  createdDate: '新規日',
  tagName: 'Tag Name',
  tagValue: 'Tag Value',
  DownloadFile: 'Do you want to save the file?',
  Succeed: 'Download Succeed.',
  Failed: 'Download Failed.',
  noFile: 'No files founded.',
  Refresh: 'お知らせ',
  Upload: 'アップロード',
  Delete: '削除＃サクジョ＃',
  BatchDownload: '一括ダウンロード',
  SendEmail: 'メールを送信',
  TransferAllToFileHistory: 'Transfer all to file history',
  ingotUpload: 'Ingot Upload',
  ingotLog: 'Ingot Log',
  synchronization: '同期',
  cancelSynchronization: '同期解除',
  synchronizationState: 'Synchronization State',
  operation: '動作',
  fileDownload: 'File Download',
  ExternalFileType: '外部ファイル種類',
  LastSyncTime: '最新同期日',
  DisplayTicketFile: 'Display ticket file',
  SendDestinationPortAgent: 'Send destination port agent',
  SentDestinationPortAgent: 'Sent destination port agent',
  ResetOneClickSend: 'Reset one click send',
  FileCreator: 'File Creator',
  FileCreationDate: 'File creation date',
  HasDeleted: 'Has it been deleted',
  SendSetOfProxyOrders: 'Send a set of proxy orders',
  ProxyName: 'Proxy Name'
}
